// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"127":"dae2e5a4","660":"f5eacf55","726":"8ef034f0","926":"f4fcbde3","989":"ba483abc"}[chunkId] + ".chunk.css";
};